import React from "react";
import {
  IonButtons,
  IonFabButton,
  IonIcon,
  IonItem,
  IonLabel,
  IonSpinner,
  IonTextarea,
} from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { sendOutline } from "ionicons/icons";
import sendMessage from "../../../store/paymentNoticeDetail/actions/sendMessage";
import UserAvatar from "../../../components/UserAvatar";
import { selectItemMessageFormDataText } from "../../../store/paymentNoticeDetail/selectors/selectItemMessageFormDataText";
import { selectSendMessageStatus } from "../../../store/paymentNoticeDetail/selectors/selectSendMessageStatus";

export const PaymentNoticeCommentBoxInput: React.FC = () => {
  const dispatch = useDispatch();

  const text = useSelector(selectItemMessageFormDataText);
  const sendMessageStatus = useSelector(selectSendMessageStatus);
  return (
    <section>
      <IonItem lines="inset">
        <UserAvatar />
        <IonLabel position="stacked">
          <h3>Escribe tu comentario</h3>
        </IonLabel>
        <IonTextarea
          value={text}
          onIonChange={(e) => {
            dispatch({
              type: "paymentNoticeDetail/updateItemMessageText",
              payload: e.detail.value,
            });
          }}
          disabled={sendMessageStatus === "pending"}
          debounce={800}
        ></IonTextarea>
        <IonButtons slot="end">
          <IonFabButton
            size="small"
            color="primary"
            onClick={() => dispatch(sendMessage())}
            class="ion-align-self-start"
            disabled={!text || sendMessageStatus === "pending"}
          >
            {sendMessageStatus !== "pending" && (
              <IonIcon size="small" icon={sendOutline} />
            )}
            {sendMessageStatus === "pending" && <IonSpinner name="dots" />}
          </IonFabButton>
        </IonButtons>
      </IonItem>
    </section>
  );
};
